export enum PropertyType {
    None,
    Date,
    Text,
    Long,
    List,
    Color,
    Workflow,
    Enum,
    DateAndTime,
    ListCustomers,
    ListUsers,
    Decimal,
    Email,
    Link,
    AutocompletionByApi,
    PhoneNumber,
}
